import { KiaPage_Pagebuilder_Blocks_LayoutKiaModules } from '@/graphql/generated/graphql';
import ModulePageBuilder from '../module-pagebuilder';

function KiaModuleBlock({ globalModule }: KiaPage_Pagebuilder_Blocks_LayoutKiaModules) {
  if (!globalModule) return null;

  return (
    <>
      {globalModule.map((module, index) => {
        if (!module?.pagebuilder) return null;
        return <ModulePageBuilder key={index} {...module.pagebuilder} />;
      })}
    </>
  );
}

export default KiaModuleBlock;
